import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import ErrorOutline from "@material-ui/icons/ErrorOutline";
import { format, parse } from "date-fns";
import { ptBR } from "date-fns/esm/locale";
import modalDetailsLast from "./modalDetailsLast";
import ModalDetailsLast from "./modalDetailsLast";

const styles = (theme) => ({
  root: {
    width: "100%",
    overflowX: "auto",
    borderRadius:20
  },
  table: {
    minWidth: 100,
  },
  recordsTable: {
    display: "flex",
    alignItems: "center",
  },
  lastRecords: {
    width: 10,
    height: 10,
    borderRadius: 50,
    padingRigth: 10,
    float: "left",
    marginRight: 8,
    display: "flex",
    alignItems: "flex-end",
  },
});

function SimpleTable(props) {
  const { classes } = props;
  const { lastRegisters } = props;
  const [openDetails, setOpenDetails] = React.useState(null);
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const auth = useSelector((state) => state.auth);
  console.log('last',lastRegisters)
  const setColor = (type) => (type === "I" ? "#79D478" : "#FC7C7C");

  const setDate = (dtRegister) => {
    const dtRef = new Date(dtRegister)
    const dayforat = dtRef.getDate().toString().padStart(2, '0'); // Dia com zero à esquerda
    const monthformat = (dtRef.getMonth() + 1).toString().padStart(2, '0'); // Mês com zero à esquerda
    const yearformat = dtRef.getFullYear();

    const formattedDate = `${dayforat}/${monthformat}/${yearformat}`;
    const date = parse(formattedDate, "dd/MM/yyyy", new Date());
    // const date = new Date(dtRegister);
    const dayName = format(date, "EEE", { locale: ptBR });
    const day = format(date, "dd", { locale: ptBR });
    const month = format(date, "MMMM", { locale: ptBR });
    const year = format(date, "yyyy", { locale: ptBR });
    const dayDetails = `${dayName}, ${day} de ${month} de ${year}`;
    return dayDetails;
  };

  const handleCloseDetails = () => {
    setOpenDetails(false);
  };

  const detailsOpen = (info) => {
    setData(info);
    setOpenDetails(true);
  };

  return (
    <Paper elevation={2} className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography variant="body1">Últimos Pontos</Typography>
            </TableCell>
          </TableRow>
          {loading ? (
            <tr>
              <TableCell padding="none">
                <LinearProgress />
              </TableCell>
            </tr>
          ) : null}
        </TableHead>
        <TableBody>
          {lastRegisters.map((row) => (
            <TableRow key={row.id}>
              <TableCell component="th" scope="row">
                <Button
                  onClick={() => detailsOpen(row)}
                  style={{ width: 340, justifyContent: "unset" }}
                >
                  <div
                    style={{
                      background: setColor(row.type),
                      width: 10,
                      height: 10,
                      borderRadius: 50,

                      float: "left",
                      marginRight: 8,
                      display: "flex",
                      alignItems: "flex-end",
                    }}
                  />
                  {/* {new Date(row.dtRegister).getHours() < 10 ? '0' + new Date(row.dtRegister).getHours() + ':' + new Date(row.dtRegister).getMinutes() : new Date(row.dtRegister).getHours() + ':' + new Date(row.dtRegister).getMinutes()} */}
                  {new Date(row.dtRegister).getUTCHours().toString().padStart(2, '0') + ':' + new Date(row.dtRegister).getUTCMinutes().toString().padStart(2, '0')}
                  <span
                    style={{
                      color: "rgba(0, 0, 0, 0.54)",
                      textTransform: "lowercase",
                      paddingLeft: 5,
                    }}
                  >
                    {setDate(row.dtRegister)}
                  </span>

                  {row.hasLocationRestrictDivergence ||
                    row.markOffScaleDivergence ||
                    row.hasPhotoRequiredDivergence ? (
                    <ErrorOutline
                      style={{ marginLeft: 15, fontSize: 18 }}
                      color="secondary"
                    />
                  ) : (
                    ""
                  )}
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <ModalDetailsLast
        open={openDetails}
        handleClose={handleCloseDetails}
        data={data}
        auth={auth}
      />
    </Paper>
  );
}

SimpleTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SimpleTable);
